import { render, staticRenderFns } from "./Part2.vue?vue&type=template&id=3133faaf&scoped=true"
import script from "./Part2.vue?vue&type=script&lang=js"
export * from "./Part2.vue?vue&type=script&lang=js"
import style0 from "./Part2.vue?vue&type=style&index=0&id=3133faaf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3133faaf",
  null
  
)

export default component.exports